<div class="icon-container"
     [style.width.px]="width"
     [style.height.px]="height">
  <div *ngIf="icon && (iconsLoaded$ | async); else loading"
       class="icon"
       [innerHTML]="iconSVG"></div>
</div>

<ng-template #loading>
  <ppl-loading-ellipsis></ppl-loading-ellipsis>
</ng-template>